export { CallosumAPI } from "./callosum-api";
export { CLIENT_TYPE_HEADER_KEY } from "./constants";
let globalCallosumAPI;
export const initGlobalCallosumApi = (callosumApi) => {
    globalCallosumAPI = callosumApi;
};
export const getGlobalCallosumApi = () => {
    return globalCallosumAPI;
};
//# sourceMappingURL=index.js.map